import React from 'react';
import classnames from 'classnames';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { Placement } from 'swag-client-common/constants';
import classes from '../cart-item/cart-item.scss';
const tooltipStyles = {
  popper: classes.boxEditBtnTooltipPopper,
  tooltip: classes.tooltipRoot
};
import cartItemClasses from '../cart-item/cart-item.scss';
import errorClasses from '../error-message/error-message.scss';
export default function HowManyInEachBox({
  quantityPerBox,
  message,
  isBoxItemInDraft = false,
  tooltipText = '',
  isGreyedOut = false
}) {
  return isBoxItemInDraft ? /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipText,
    placement: Placement.RIGHT,
    mode: "light",
    className: classes.infoWrapper,
    classes: tooltipStyles
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: cartItemClasses.secondaryTitle
  }, "Quantity Per Box:"), /*#__PURE__*/React.createElement("b", {
    className: classnames(cartItemClasses.prodPricePink, cartItemClasses.howManyInEachBoxCol, {
      [cartItemClasses.greyedOut]: isGreyedOut
    })
  }, quantityPerBox), message && /*#__PURE__*/React.createElement("span", {
    className: classnames(errorClasses.wrapper, cartItemClasses.howManyInEachBoxCol)
  }, message.isSuccessed && message.extraMessage ? message.extraMessage : ''))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: cartItemClasses.secondaryTitle
  }, "Quantity Per Box:"), /*#__PURE__*/React.createElement("b", {
    className: classnames(cartItemClasses.prodPricePink, cartItemClasses.howManyInEachBoxCol, {
      [cartItemClasses.greyedOut]: isGreyedOut
    })
  }, quantityPerBox), message && /*#__PURE__*/React.createElement("span", {
    className: classnames(errorClasses.wrapper, cartItemClasses.howManyInEachBoxCol)
  }, message.isSuccessed && message.extraMessage ? message.extraMessage : ''));
}